// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services-grid-block {
  margin: 0 0 36px 0;
  padding: 0 0 18px 0;
}
.services-grid-block .services-grid-title {
  font-size: 1.18rem;
  font-weight: 800;
  margin-bottom: 22px;
  color: #222a3c;
  letter-spacing: -0.02em;
  padding-left: 2px;
}
.services-grid-block .services-grid-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px 18px;
  width: 100%;
}
.services-grid-block .services-grid-list .services-card {
  text-decoration: none;
  color: inherit;
  position: relative;
  border-radius: 22px;
  box-shadow: 0 4px 18px 0 rgba(36, 41, 57, 0.08);
  display: flex;
  align-items: center;
  min-height: 90px;
  padding: 24px 0 22px 0;
  overflow: hidden;
  background: #f7fafd;
  cursor: pointer;
  transition: box-shadow 0.14s, transform 0.13s, background 0.19s;
  z-index: 1;
}
.services-grid-block .services-grid-list .services-card:not(.disabled):hover, .services-grid-block .services-grid-list .services-card:not(.disabled):focus {
  box-shadow: 0 14px 36px 0 rgba(36, 41, 57, 0.16);
  transform: translateY(-3px) scale(1.012);
  background: #f4f7fa;
}
.services-grid-block .services-grid-list .services-card.wide {
  grid-column: span 2;
  min-height: 105px;
  padding: 32px 40px 26px 28px;
}
.services-grid-block .services-grid-list .services-card.wide .services-card-title {
  font-size: 1.17rem;
}
.services-grid-block .services-grid-list .services-card.wide .services-card-desc {
  font-size: 1.07rem;
}
.services-grid-block .services-grid-list .services-card.disabled {
  pointer-events: none;
  opacity: 0.6;
  cursor: default;
  box-shadow: 0 4px 18px 0 rgba(36, 41, 57, 0.08);
  transform: none;
  background: inherit;
}
.services-grid-block .services-card-accent {
  position: absolute;
  right: -18px;
  bottom: -18px;
  width: 76px;
  height: 76px;
  border-radius: 56px 23px 0 60px;
  z-index: 0;
}
.services-grid-block .services-card-icon {
  font-size: 2.2rem;
  margin-right: 17px;
  z-index: 1;
  min-width: 2.7rem;
  text-align: center;
  filter: drop-shadow(0 6px 18px rgba(207, 212, 239, 0.0901960784));
}
.services-grid-block .services-card-content {
  display: flex;
  flex-direction: column;
  z-index: 1;
  min-width: 0;
  width: 100%;
}
.services-grid-block .services-card-title {
  font-size: 1.07rem;
  font-weight: 700;
  color: #222a3c;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.services-grid-block .services-card-title .services-soon {
  font-size: 0.74rem;
  font-weight: 600;
  margin-left: 8px;
  color: #e72f44;
  background: rgba(231, 47, 68, 0.1);
  padding: 2px 6px;
  border-radius: 8px;
  vertical-align: middle;
}
.services-grid-block .services-card-desc {
  font-size: 0.99rem;
  color: #7d8ca6;
  line-height: 1.17;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 950px) {
  .services-grid-block .services-grid-list {
    grid-template-columns: 1fr 1fr;
    gap: 18px 8px;
  }
  .services-grid-block .services-card {
    min-height: 72px;
    padding: 14px 10px 13px 9px;
  }
  .services-grid-block .services-card .services-card-icon {
    font-size: 1.6rem;
    margin-right: 10px;
  }
  .services-grid-block .services-card .services-card-title {
    font-size: 0.99rem;
  }
  .services-grid-block .services-card .services-card-desc {
    font-size: 0.88rem;
  }
  .services-grid-block .services-card.wide {
    grid-column: span 2;
    min-height: 90px;
    padding: 17px 13px 14px 11px;
  }
}
@media (max-width: 700px) {
  .services-grid-block .services-grid-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px 7px;
  }
  .services-grid-block .services-card,
  .services-grid-block .services-card.wide {
    grid-column: span 2;
    min-height: 64px;
    padding: 12px 6px 11px 6px;
  }
  .services-grid-block .services-card .services-card-icon,
  .services-grid-block .services-card.wide .services-card-icon {
    font-size: 1.28rem;
    margin-right: 7px;
  }
  .services-grid-block .services-card .services-card-title,
  .services-grid-block .services-card.wide .services-card-title {
    font-size: 0.91rem;
  }
  .services-grid-block .services-card .services-card-desc,
  .services-grid-block .services-card.wide .services-card-desc {
    font-size: 0.82rem;
  }
  .services-grid-block .services-card:not(.wide) {
    grid-column: span 1;
  }
}
@media (max-width: 500px) {
  .services-grid-block .services-grid-list {
    gap: 7px 4px;
  }
  .services-grid-block .services-card,
  .services-grid-block .services-card.wide {
    min-height: 52px;
    padding: 7px 3px 6px 4px;
  }
  .services-grid-block .services-card .services-card-icon,
  .services-grid-block .services-card.wide .services-card-icon {
    font-size: 1rem;
    margin-right: 5px;
  }
}
@media (max-width: 500px) {
  .services-grid-block .services-grid-list {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .services-grid-block .services-grid-list .services-card,
  .services-grid-block .services-grid-list .services-card.wide,
  .services-grid-block .services-grid-list .services-card:not(.wide) {
    grid-column: 1/-1;
    min-height: 72px;
    padding: 12px;
  }
  .services-grid-block .services-grid-list .services-card .services-card-icon,
  .services-grid-block .services-grid-list .services-card.wide .services-card-icon,
  .services-grid-block .services-grid-list .services-card:not(.wide) .services-card-icon {
    min-width: 2rem;
    margin-right: 10px;
    font-size: 1.35rem;
  }
  .services-grid-block .services-grid-list .services-card .services-card-title,
  .services-grid-block .services-grid-list .services-card.wide .services-card-title,
  .services-grid-block .services-grid-list .services-card:not(.wide) .services-card-title {
    overflow: visible;
    font-size: 0.98rem;
    line-height: 1.2;
    text-overflow: clip;
    white-space: normal;
  }
  .services-grid-block .services-grid-list .services-card .services-card-desc,
  .services-grid-block .services-grid-list .services-card.wide .services-card-desc,
  .services-grid-block .services-grid-list .services-card:not(.wide) .services-card-desc {
    display: -webkit-box;
    overflow: hidden;
    font-size: 0.86rem;
    line-height: 1.25;
    white-space: normal;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}

.services-newtab {
  margin-left: 8px;
  font-size: 0.9em;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  opacity: 0.75;
}

.services-newtab {
  margin-left: 8px;
  font-size: 0.9em;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  opacity: 0.75;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/block/ServicesGrid/ServicesGrid.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AACJ;AAEE;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EACA,WAAA;AAAJ;AAGI;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,+CAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,+DAAA;EACA,UAAA;AADN;AAGM;EAEE,gDAAA;EACA,wCAAA;EACA,mBAAA;AAFR;AAKM;EACE,mBAAA;EACA,iBAAA;EACA,4BAAA;AAHR;AAKQ;EAAuB,kBAAA;AAF/B;AAGQ;EAAsB,kBAAA;AAA9B;AAGM;EACE,oBAAA;EACA,YAAA;EACA,eAAA;EACA,+CAAA;EACA,eAAA;EACA,mBAAA;AADR;AAME;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,UAAA;AAJJ;AAOE;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,iEAAA;AALJ;AAQE;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AANJ;AASE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPJ;AASI;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AAPN;AAWE;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AATJ;AAYE;EACE;IACE,8BAAA;IACA,aAAA;EAVJ;EAaE;IACE,gBAAA;IACA,2BAAA;EAXJ;EAaI;IAAsB,iBAAA;IAAmB,kBAAA;EAT7C;EAUI;IAAuB,kBAAA;EAP3B;EAQI;IAAsB,kBAAA;EAL1B;EAOI;IACE,mBAAA;IACA,gBAAA;IACA,4BAAA;EALN;AACF;AASE;EACE;IACE,qCAAA;IACA,aAAA;EAPJ;EAUE;;IAEE,mBAAA;IACA,gBAAA;IACA,0BAAA;EARJ;EAUI;;IAAsB,kBAAA;IAAoB,iBAAA;EAL9C;EAMI;;IAAuB,kBAAA;EAF3B;EAGI;;IAAsB,kBAAA;EAC1B;EAEE;IACE,mBAAA;EAAJ;AACF;AAGE;EACE;IACE,YAAA;EADJ;EAIE;;IAEE,gBAAA;IACA,wBAAA;EAFJ;EAII;;IAAsB,eAAA;IAAiB,iBAAA;EAC3C;AACF;AAEE;EACE;IACE,0BAAA;IACA,SAAA;EAAJ;EAGE;;;IAGE,iBAAA;IACA,gBAAA;IACA,aAAA;EADJ;EAGI;;;IACE,eAAA;IACA,kBAAA;IACA,kBAAA;EACN;EAEI;;;IACE,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;IACA,mBAAA;EAEN;EACI;;;IACE,oBAAA;IACA,gBAAA;IACA,kBAAA;IACA,iBAAA;IACA,mBAAA;IACA,4BAAA;IACA,qBAAA;EAGN;AACF;;AACA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;AAEF;;AAAA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,aAAA;AAGF","sourcesContent":[".services-grid-block {\r\n  margin: 0 0 36px 0;\r\n  padding: 0 0 18px 0;\r\n\r\n  .services-grid-title {\r\n    font-size: 1.18rem;\r\n    font-weight: 800;\r\n    margin-bottom: 22px;\r\n    color: #222a3c;\r\n    letter-spacing: -0.02em;\r\n    padding-left: 2px;\r\n  }\r\n\r\n  .services-grid-list {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 30px 18px;\r\n    width: 100%;\r\n\r\n    // Карточка (и ссылка, и div)\r\n    .services-card {\r\n      text-decoration: none;\r\n      color: inherit;\r\n      position: relative;\r\n      border-radius: 22px;\r\n      box-shadow: 0 4px 18px 0 rgba(36,41,57,0.08);\r\n      display: flex;\r\n      align-items: center;\r\n      min-height: 90px;\r\n      padding: 24px 0 22px 0;\r\n      overflow: hidden;\r\n      background: #f7fafd;\r\n      cursor: pointer;\r\n      transition: box-shadow .14s, transform .13s, background .19s;\r\n      z-index: 1;\r\n\r\n      &:not(.disabled):hover,\r\n      &:not(.disabled):focus {\r\n        box-shadow: 0 14px 36px 0 rgba(36,41,57,0.16);\r\n        transform: translateY(-3px) scale(1.012);\r\n        background: #f4f7fa;\r\n      }\r\n\r\n      &.wide {\r\n        grid-column: span 2;\r\n        min-height: 105px;\r\n        padding: 32px 40px 26px 28px;\r\n\r\n        .services-card-title { font-size: 1.17rem; }\r\n        .services-card-desc { font-size: 1.07rem; }\r\n      }\r\n\r\n      &.disabled {\r\n        pointer-events: none;\r\n        opacity: 0.6;\r\n        cursor: default;\r\n        box-shadow: 0 4px 18px 0 rgba(36,41,57,0.08);\r\n        transform: none;\r\n        background: inherit;\r\n      }\r\n    }\r\n  }\r\n\r\n  .services-card-accent {\r\n    position: absolute;\r\n    right: -18px;\r\n    bottom: -18px;\r\n    width: 76px;\r\n    height: 76px;\r\n    border-radius: 56px 23px 0 60px;\r\n    z-index: 0;\r\n  }\r\n\r\n  .services-card-icon {\r\n    font-size: 2.2rem;\r\n    margin-right: 17px;\r\n    z-index: 1;\r\n    min-width: 2.7rem;\r\n    text-align: center;\r\n    filter: drop-shadow(0 6px 18px #cfd4ef17);\r\n  }\r\n\r\n  .services-card-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    z-index: 1;\r\n    min-width: 0;\r\n    width: 100%;\r\n  }\r\n\r\n  .services-card-title {\r\n    font-size: 1.07rem;\r\n    font-weight: 700;\r\n    color: #222a3c;\r\n    margin-bottom: 4px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n\r\n    .services-soon {\r\n      font-size: 0.74rem;\r\n      font-weight: 600;\r\n      margin-left: 8px;\r\n      color: #e72f44;\r\n      background: rgba(231,47,68,0.1);\r\n      padding: 2px 6px;\r\n      border-radius: 8px;\r\n      vertical-align: middle;\r\n    }\r\n  }\r\n\r\n  .services-card-desc {\r\n    font-size: 0.99rem;\r\n    color: #7d8ca6;\r\n    line-height: 1.17;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  @media (max-width: 950px) {\r\n    .services-grid-list {\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 18px 8px;\r\n    }\r\n\r\n    .services-card {\r\n      min-height: 72px;\r\n      padding: 14px 10px 13px 9px;\r\n\r\n      .services-card-icon { font-size: 1.6rem; margin-right: 10px; }\r\n      .services-card-title { font-size: 0.99rem; }\r\n      .services-card-desc { font-size: 0.88rem; }\r\n\r\n      &.wide {\r\n        grid-column: span 2;\r\n        min-height: 90px;\r\n        padding: 17px 13px 14px 11px;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 700px) {\r\n    .services-grid-list {\r\n      grid-template-columns: repeat(2, 1fr);\r\n      gap: 12px 7px;\r\n    }\r\n\r\n    .services-card,\r\n    .services-card.wide {\r\n      grid-column: span 2;\r\n      min-height: 64px;\r\n      padding: 12px 6px 11px 6px;\r\n\r\n      .services-card-icon { font-size: 1.28rem; margin-right: 7px; }\r\n      .services-card-title { font-size: 0.91rem; }\r\n      .services-card-desc { font-size: 0.82rem; }\r\n    }\r\n\r\n    .services-card:not(.wide) {\r\n      grid-column: span 1;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 500px) {\r\n    .services-grid-list {\r\n      gap: 7px 4px;\r\n    }\r\n\r\n    .services-card,\r\n    .services-card.wide {\r\n      min-height: 52px;\r\n      padding: 7px 3px 6px 4px;\r\n\r\n      .services-card-icon { font-size: 1rem; margin-right: 5px; }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 500px) {\n    .services-grid-list {\n      grid-template-columns: 1fr;\n      gap: 10px;\n    }\n\n    .services-grid-list .services-card,\n    .services-grid-list .services-card.wide,\n    .services-grid-list .services-card:not(.wide) {\n      grid-column: 1 / -1;\n      min-height: 72px;\n      padding: 12px;\n\n      .services-card-icon {\n        min-width: 2rem;\n        margin-right: 10px;\n        font-size: 1.35rem;\n      }\n\n      .services-card-title {\n        overflow: visible;\n        font-size: 0.98rem;\n        line-height: 1.2;\n        text-overflow: clip;\n        white-space: normal;\n      }\n\n      .services-card-desc {\n        display: -webkit-box;\n        overflow: hidden;\n        font-size: 0.86rem;\n        line-height: 1.25;\n        white-space: normal;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;\n      }\n    }\n  }\n}\n.services-newtab {\n  margin-left: 8px;\n  font-size: 0.9em;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  opacity: .75;\n}\n.services-newtab {\n  margin-left: 8px;\n  font-size: 0.9em;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  opacity: .75;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
